/**
 * Class-name helper for the vendored shadcn primitives.
 *
 * tailwind-merge has to learn our type scale (`text-body`, `text-h3`, …, from
 * the `--text-*` keys in src/styles/tokens.css). Without this it reads
 * `text-body` as a text *color* and drops it when a `text-navy-*` class follows,
 * silently losing the font size (style guide §3, §10.3).
 */
import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      'font-size': [
        'text-overline',
        'text-body',
        'text-body-sm',
        'text-caption',
        'text-h1',
        'text-h2',
        'text-h3',
        'text-stat',
        'text-display',
        'text-display-xl',
      ],
    },
  },
})

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
